import { render, staticRenderFns } from "./Homes.vue?vue&type=template&id=2292bd2e"
import script from "./Homes.vue?vue&type=script&lang=js"
export * from "./Homes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports